module.exports = __webpack_public_path__ + "img/privacyandpolicy.aeeac15e.svg";